import { c as _c } from "react/compiler-runtime";
import type { LiveItem } from '@module/apis/client-side/live/type';
import type { FetchNextPageOptions, InfiniteQueryObserverResult } from '@tanstack/react-query';
import BroadcastUserItem from '../../list/broadcast/BroadcastUserItem';
import BroadcastUserList from '../../list/broadcast/BroadcastUserList';
interface Props {
  list?: LiveItem[];
  observerRef?: (node?: Element | null | undefined) => void;
  // topObserverRef?: (node?: Element | null | undefined) => void;
  className?: string;
  fetchNextPage?: (options?: FetchNextPageOptions) => Promise<InfiniteQueryObserverResult<{
    pages: LiveItem[];
    pageParams: unknown[];
    total: number;
  }, Error>>;
  hasNextPage?: boolean;
}
function BroadcastList(t0) {
  const $ = _c(17);
  const {
    list,
    className,
    observerRef,
    fetchNextPage,
    hasNextPage
  } = t0;
  let t1;
  if ($[0] !== list) {
    t1 = list?.map(_temp);
    $[0] = list;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== className || $[5] !== t2) {
    t3 = <BroadcastUserList className={className}>{t2}</BroadcastUserList>;
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== fetchNextPage || $[8] !== hasNextPage || $[9] !== list) {
    t4 = list && hasNextPage && fetchNextPage && <div className="mb-[50px] flex justify-center"><button className=" flex h-[48px] w-[120px] items-center justify-center rounded-[24px] bg-colorBg22 font-[15px] text-borderBg16 hover:underline " onClick={() => fetchNextPage()}>+ 더보기</button></div>;
    $[7] = fetchNextPage;
    $[8] = hasNextPage;
    $[9] = list;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== observerRef) {
    t5 = observerRef && <div id="bottom-observer-ref" className="h-8 w-full" ref={observerRef} />;
    $[11] = observerRef;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <>{t3}{t4}{t5}</>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
function _temp(item, index) {
  return <BroadcastUserItem key={index} item={item} />;
}
export default BroadcastList;